export default "__VITE_ASSET__DOdTksNb__"